import { Injectable } from '@angular/core';

/** Cross-tab parked expiry used to live in the in-app mock store; the mock API owns that state now. */
@Injectable({ providedIn: 'root' })
export class EventParkedSyncService {}
